import * as algoliasearch from 'algoliasearch';
import * as moment from 'moment';
import { alogoliaAccount, algoliaKey, miscFirebaseToolsIpReal } from '../../../../config/constants';
import axios from 'axios'

export function getLargeProjectItem(grouping,itemType, returnFunction) {
    console.log("alglxf1m +++++++++++: getLargeProjectItem");
    console.log("alglxf12m grouping:" + grouping);
    console.log("alglxf12m itemType:" + itemType);

    var client = algoliasearch(alogoliaAccount, "8e5749e7e5541843a90b60444b68b182");
    var index = client.initIndex('printb_values');

    index.search({
        query: '',
        attributesToHighlight: [],
        //  facetQuery: '',
        filters: 'grouping:' + grouping + ' AND valid:' + true + ' AND itemType:' + itemType
    }).then(content => {
        // console.log("alglxf13:" + JSON.stringify(content.hits, null, 3));

        returnFunction(content.hits);
    }).catch(function (err) {
        console.log(err);
        console.log(err.debugData);

        //return 'error'
    });
}

export function getOrderByOrderNum(order_num, returnFunction) {
    console.log("artx2 +++++++++++: getOrderByOrderNum");
    console.log("artx21 order_num:" + order_num);

    var client = algoliasearch(alogoliaAccount, algoliaKey);
    var index = client.initIndex('printboda_test');


    index.search({
        query: order_num,
        attributesToHighlight: [],
        //  facetQuery: '',
        //filters: 'order_num:' + order_num
        //filters: 'order_num:27812' 
    }).then(content => {
        console.log("artx20 return size:"+content.hits.length)
        console.log("artx22:" + JSON.stringify(content.hits, null, 3));


        returnFunction(content.hits);
    }).catch(function (err) {
        console.log(err);
        console.log(err.debugData);

        return 'error'
    });
}

export function getOrderFromAlogolia(fbOrderKey, returnFunction){
    console.log("golx1 +++++++++++: checkAdminEmail");
    console.log("golx12 fbOrderKey:" + fbOrderKey);

    var client = algoliasearch(alogoliaAccount, algoliaKey);
    var index = client.initIndex('printboda_test');

    index.getObject(fbOrderKey, (err, content) => {
        console.log("golx13 found order:"+JSON.stringify(content,null,3));

        returnFunction(content)
      });
}

export async function checkAdminEmail(adminEmail, returnFunction) {
    // console.log("soarch20 +++++++++++: checkAdminEmail");
    // console.log("soarch21 adminEmail:" + adminEmail);

    var client = algoliasearch(alogoliaAccount, algoliaKey);
    var index = client.initIndex('printb_values');

    try {
        // const content = await index.search({ query: "jack@jack.com", filters: 'grouping:adminemail' });
        const content = await index.search({ query: adminEmail, filters: 'grouping:adminemail', attributesToHighlight: [], });
       // console.log("addx2932 content adminEmail found:");
        // console.log("addx2933 reply:"+JSON.stringify(content,null,3));
       // console.log("addx2934 reply.hits:" + JSON.stringify(content.hits, null, 3));

        if (!Array.isArray(content.hits) || !content.hits.length) {
           // console.log("addx2935 email not found");

            let result = {};
            result.result = false;
            result.isAdmin = false;
            result.algoliaUser = null;
            returnFunction(result);

        } else {
           // console.log("addx2936 email found");
            let result = {};
            result.result = true;
            result.isAdmin = true;
            result.algoliaUser = content.hits[0];

            returnFunction(result);
        }

    } catch (error) {
        // console.log("addx2937 error....");
        // console.log(error);
        let result = {};
        result.result = false;
        result.admin = false;

        returnFunction(result);
    }

    // index.search({
    //     query: adminEmail,
    //     //  facetQuery: '',
    //     filters: 'grouping:adminemail'
    // }).then(content => {
    //     console.log("addx31:" + JSON.stringify(content.hits, null, 3));

    //     returnFunction(content.hits);
    // }).catch(function (err) {
    //     console.log(err);
    //     console.log(err.debugData);

    //     return 'error'
    // });
}

export function getSubCategoryCards(grouping, returnFunction) {
    // console.log("alglxf1m +++++++++++: getSubCategoryCards");
    // console.log("alglxf12m grouping:" + grouping);

    var client = algoliasearch(alogoliaAccount, algoliaKey);
    var index = client.initIndex('printb_values');

    index.search({
        query: '',
        //  facetQuery: '',
        filters: 'grouping:' + grouping + ' AND valid:' + true + ' '
    }).then(content => {
        // console.log("alglxf13:" + JSON.stringify(content.hits, null, 3));

        returnFunction(content.hits);
    }).catch(function (err) {
        console.log(err);
        console.log(err.debugData);

        //return 'error'
    });


}


export function getSpecificOrderCard(itemType, returnFunction) {
    console.log("edx2 +++++++++++: getSpecificOrderCard");
    console.log("edx21 itemType:" + itemType);

    var client = algoliasearch(alogoliaAccount, algoliaKey);
    var index = client.initIndex('printb_values');

    index.search({
        query: '',
        //  facetQuery: '',
        filters: 'itemType:storageBoxes'
    }).then(content => {
        //console.log("edx23:" + JSON.stringify(content.hits, null, 3));


        returnFunction(content.hits);
    }).catch(function (err) {
        console.log(err);
        console.log(err.debugData);

        return 'error'
    });
}


export function getArtist(artist, returnFunction, artistEmail) {
    console.log("artx2 +++++++++++: getArtist");
    console.log("artx21 artist:" + artist);
    console.log("artx22 artistEmail:" + artistEmail);

    var client = algoliasearch(alogoliaAccount, algoliaKey);
    var index = client.initIndex('artists');

    index.search({
        query: '',
        //  facetQuery: '',
        filters: 'urlname:' + artist
    }).then(content => {
        console.log("artx22:" + JSON.stringify(content.hits, null, 3));


        returnFunction(content.hits, artistEmail);
    }).catch(function (err) {
        console.log(err);
        console.log(err.debugData);

        return 'error'
    });
}

export function getMainCardObjects(grouping, returnFunction) {
    // console.log("alglxf1m +++++++++++: getMainCardObjects");
    // console.log("alglxf12m grouping:" + grouping);

    var client = algoliasearch(alogoliaAccount, algoliaKey);
    var index = client.initIndex('printb_values');

    index.search({
        query: '',
        //  facetQuery: '',
        filters: 'grouping:' + grouping + ' AND valid:' + true
    }).then(content => {
        // console.log("alglxf13:" + JSON.stringify(content.hits, null, 3));

        returnFunction(content.hits);
    }).catch(function (err) {
        console.log(err);
        console.log(err.debugData);

        //return 'error'
    });
}

export function algoliaPartialUpdateOrder(updateObject){
    console.log("algPud3 fbx31 ++++++++ updateAlgoliaUpdateOnArchivedOrder ");
    console.log("algPud31 fbx32 updateObject:" + JSON.stringify(updateObject,null,3));

    axios.post(miscFirebaseToolsIpReal + 'partialUpdateOrderInAlgolia', {
        apiKey: "ad#4fsdUUddf",
        updateObject: updateObject
    })
        .then((response) => {
            console.log("algPud32:"+JSON.stringify(response.data, null, 3));

            if (response.data.result) {

            } else {
 
            }
            //this.resetFields();
        })
        .catch((error) => {
            console.log("algPud33:"+error);
        });

}

// updateAlgoliaUpdateOnArchivedOrder(this.props.order.objectID,this.state.updateText, userEmail);
export function updateAlgoliaUpdateOnArchivedOrder(orderID, updateText,userEmail) {
    console.log("achx1 ++++++++ updateAlgoliaUpdateOnArchivedOrder ");
    console.log("achx12 orderID:" + orderID);
    console.log("achx13 userEmail:" + userEmail);
    console.log("achx13 updateText:" + updateText);

    let now = moment().format('MMMM Do, h:mm:ss a');

    let updateObject = {
        updateText: updateText,
        lastUpdated: now,
        lastUpdatedBy: userEmail,
        objectID: orderID
    }

    console.log("achx14:"+JSON.stringify(updateObject, null, 3));

    axios.post(miscFirebaseToolsIpReal + 'updateAlgoliaUpdateOnArchivedOrder', {
        apiKey: "ad#4fsdUUddf",
        updateObject: updateObject
    })
        .then((response) => {
            console.log("algPud32:"+JSON.stringify(response.data, null, 3));

            if (response.data.result) {

            } else {
 
            }
            //this.resetFields();
        })
        .catch((error) => {
            console.log("algPud33:"+error);
        });

}

export function getPrintValues(grouping, returnFunction) {
    // console.log("alglxf1 +++++++++++: getPrintValues");
    // console.log("alglxf12 grouping:" + grouping);

    var client = algoliasearch(alogoliaAccount, algoliaKey);
    var index = client.initIndex('printb_values');

    index.search({
        query: '',
        //  facetQuery: '',
        filters: 'grouping:' + grouping
    }).then(content => {
        // console.log("alglxf13:" + JSON.stringify(content.hits, null, 3));

        returnFunction(content.hits);
    }).catch(function (err) {
        console.log(err);
        console.log(err.debugData);

        //return 'error'
    });


}

export function getDesigners(returnFunction) {

    var client = algoliasearch(alogoliaAccount, algoliaKey);
    var index = client.initIndex('printb_values');

    index.search({
        query: '',
        //  facetQuery: '',
        filters: 'grouping:design'
    }).then(content => {
       // console.log("aglx91:" + JSON.stringify(content.hits, null, 3));

        returnFunction(content.hits);
        //return content.hits;
    }).catch(function (err) {
        console.log(err);
        console.log(err.debugData);

        return 'error'
    });
}


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/algoliaDashboard/AlgoliaMiscUtils.js